import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IExamReport } from "../exam_papers/getExamReport";

// API function to get exam report by ID
export const apiGetExamReport = async (id: string) => {
  const response = await apiGet<IExamReport>(`/exam_reports/${id}`);
  return response.data;
};

// React Query hook
export const useQueryGetExamReport = (id: string) => {
  return useQuery({
    queryKey: QueryKeys.examReport.detail(id),
    queryFn: () => apiGetExamReport(id),
  });
};
